import {useState, useEffect} from "react"
import moment from "moment";

import DataCard from "../../../shared/components/DataCard";
import DonatChart from "../../../shared/components/DonatChart";
import LineChart from "../../../shared/components/LineChart";
import ColumnChart from "../../../shared/components/ColumnChart";
import SeeMore from "../../../shared/components/SeeMore";

import styles from "./dashboard-charts.module.scss";

import {registeredUsersData, activeMissionsData, donatData, donatSummaryData, lineData} from "./data";

import {getAll} from "../../../shared/services/dashboards"

const DashboardCharts = ({dateRange}) => {
    const [data, setData] = useState({});

    useEffect(()=> {
        const fetchData = async () => {
            try {
                const result = await getAll();
                setData(result)
                // console.log(result)
            }
            catch(error) {
                console.log(error)
            }
        }

        fetchData()
    }, [])

    if(!data.users && !data.missions) {
        return (
            <div className={styles.wrapper}></div>
        )
    }

    // const test = data.users.filter(({date}) => {
    //     const userDate = moment(date);
    //     if(dateRange) {
    //         return (dateRange[0] <= userDate && dateRange[1] >= userDate)
    //     }
    // });

    const users = dateRange ? data.users.filter(({date}) => {
        const userDate = moment(date);
        if(dateRange) {
            return (dateRange[0] <= userDate && dateRange[1] >= userDate)
        }
    }) : data.users;
    const missions = dateRange ? data.missions.filter(({event_date}) => {
        const missionDate = moment(event_date);
        return dateRange[0] <= missionDate && dateRange[1] >= missionDate;
    }) : data.missions;

    const currentMonth = moment().format("YYYY-MM");
    const previousMonth = moment().subtract(1, "month").format("YYYY-MM");

    const totalRegisteredUsers = users.length;
    const usersPrevMonth = users.filter(({date}) => {
        return date?.slice(0, 7) === previousMonth;
    }).length;

    const usersThisMonth = users.filter(({date}) => {
        return date?.slice(0, 7) === currentMonth;
    }).length;

    const prevMonthTotal = Boolean(usersPrevMonth) ? usersPrevMonth : 1;

    const registerUserPercent = (((usersThisMonth - usersPrevMonth) / (prevMonthTotal)) * 100).toFixed(2);

    const activeMissionsPrevMonth = missions.filter(({event_date, status}) =>{
        return [1, 2, 3, 4, 5].includes(status) && event_date?.slice(0, 7) === previousMonth;
    }).length;

    const activeMissionsThisMonth = missions.filter(({event_date, status}) => {
        return [1, 2, 3, 4, 5].includes(status) && event_date?.slice(0, 7) === currentMonth;
    }).length;

    const prevMonthMissionTotal = Boolean(activeMissionsPrevMonth) ? activeMissionsPrevMonth : 1;

    const activeMissionsPercent = (((activeMissionsThisMonth - activeMissionsPrevMonth) / (prevMonthMissionTotal)) * 100).toFixed(2);

    const clientsTotal = users.filter(({type, approve}) => (type === 2 || type === 3) && approve === 1).length;

    const delegatesTotal = users.filter(({type, approve}) => type === 1 && approve === 1).length;

    const pendingTotal = users.filter(({type, approve}) => approve === 0).length;

    const usersTypeData = [
        {
            type: 'Clients',
            value: clientsTotal,
        },
        {
            type: 'Delegates',
            value: delegatesTotal,
        },
        {
            type: 'Pending',
            value: pendingTotal,
        },
    ];

    const usersTypeSummary = [clientsTotal, delegatesTotal, pendingTotal];

    const uniqueMonth = users.reduce((acum, {date}) => {
        const data = date.slice(0, 7);
        if(!acum.includes(data)) {
            return [...acum, data]
        }
        return acum;
    }, []).map(item => ({Date: item, scales: 0}));

    const someData = users.reduce((acum, {date: userDate})=> {
        const index = acum.findIndex(({Date}) => Date === userDate.slice(0, 7));
        acum[index].scales += 1;
        return acum;

    }, [...uniqueMonth])

    return (
        <div className={styles.wrapper}>
            <div>
                <div className={`${styles.block} ${styles.dataWrapper}`}>
                    <DataCard {...registeredUsersData} total={totalRegisteredUsers} percent={!dateRange ? registerUserPercent : null} />
                    <DataCard {...activeMissionsData} total={activeMissionsThisMonth} percent={!dateRange ? activeMissionsPercent : null} />
                </div>

                <div className={styles.block}>
                    <DonatChart title="Types of Users" data={usersTypeData} summary={usersTypeSummary} />
                </div>
            </div>

            <div>
                <div className={styles.block}>
                    <LineChart title="Popularity Growth" data={someData} />
                </div>
                <SeeMore />
                {/*<div className={`${styles.block} ${styles.lastInfo}`}>*/}
                {/*    <div>*/}
                {/*        <ColumnChart />*/}
                {/*    </div>*/}
                {/*    <div>*/}
                {/*        <div className={styles.block}>*/}
                {/*            <DataCard {...activeMissionsData} />*/}
                {/*        </div>*/}
                {/*        <div className={styles.block}>*/}
                {/*            <SeeMore />*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>

        </div>
    )
}

export default DashboardCharts;
